module.exports = __webpack_public_path__ + "img/introduccion.e08c33de.svg";